import * as React from 'react'
import { Payments } from './Payments'
import { getStyles } from './useStyles'
import { Agreements } from './Agreements'
import { Appointments } from './Appointments'
import { ServicesAdded } from './ServicesAdded'
import { AdditionalInfoEdit } from './AdditionalInfo'
import type { SoldServicesContentProps } from '../typings'
import { useSchedulingEnabled } from '@user/store/scheduling'
import Box from '@mui/material/Box'
import { useTheme } from '@mui/material/styles'

export function SoldServicesContent(props: SoldServicesContentProps) {
  const styles = getStyles(useTheme())

  const footerRef = React.useRef(null)

  const schedulingEnabled = useSchedulingEnabled()

  return (
    <Box sx={styles.container}>
      <Box sx={styles.content}>
        {schedulingEnabled && <Appointments {...props} />}
        <ServicesAdded {...props} />
        <Agreements {...props} />
        <Payments {...props} />
        <AdditionalInfoEdit {...props} footerInstance={footerRef.current} />
      </Box>
      <Box ref={footerRef} sx={styles.footer} />
    </Box>
  )
}
